// extracted by mini-css-extract-plugin
export var attachment = "_mp-a";
export var emailContainer = "_mp-4";
export var emailContentPaddedContainer = "_mp-b";
export var emailHeader = "_mp-6";
export var emailIframe = "_mp-3";
export var emailInfoIcon = "_mp-9";
export var emailShortenedSummary = "_mp-e";
export var infoDropdown = "_mp-0";
export var infoRowBoundedContent = "_mp-d";
export var internal = "_mp-5";
export var merchant = "_mp-8";
export var messageInputContainer = "_mp-h";
export var normal = "_mp-7";
export var replyCard = "_mp-f";
export var subtleButton = "_mp-1";
export var subtleButtonIconContainer = "_mp-2";
export var toggleViewRepliesButton = "_mp-c";
export var wrappingText = "_mp-g";